import { Button, styled, Tooltip } from 'opensolar-ui'
import useTranslateWithVariable from 'projectSections/hooks/useTranslateWithVariable'
import { FC } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { DialogHelper } from 'util/misc'

type PropsType = {
  enabled: boolean
  isLoading?: boolean
  orgName?: string
  multiSelect?: boolean
  handleSelect(): void
}

const StyledSelectButton = styled(Button)({
  color: '#212121 !important',
  border: '2px solid #E7E7E7 !important',
  backgroundColor: '#F8F8F8 !important',
  fontSize: '13px !important',
  '&:hover': {
    border: '2px solid #B4B4B4 !important',
    boxShadow: '0px 4px 5px rgba(0,0,0,0.14),0px 1px 10px rgba(0,0,0,0.12) !important',
  },
})

const QUANTITY_CONTROL_WIDTH = 108

const SelectButton: FC<PropsType> = ({ enabled, isLoading = false, orgName, multiSelect = false, handleSelect }) => {
  const notify = useNotify()
  const translate = useTranslate()
  const translateWithVariable = useTranslateWithVariable()

  if (enabled) {
    return (
      <StyledSelectButton
        disabled={isLoading}
        variant="contained"
        size="small"
        style={multiSelect ? { minWidth: QUANTITY_CONTROL_WIDTH } : undefined}
        onClick={(e) => {
          e.stopPropagation()
          DialogHelper.beforeClose()
          handleSelect()
        }}
      >
        <span>{translate('Select')}</span>
      </StyledSelectButton>
    )
  } else {
    return (
      <Tooltip
        title={translate('Request admin to activate this component or to update your role permissions')}
        PopperProps={{ style: { zIndex: 2001 } }}
        placement="top"
        arrow
      >
        <Button
          variant="outlined"
          style={{
            background: 'rgba(0, 0, 0, 0.12)',
            color: 'rgba(0, 0, 0, 0.26)',
            cursor: 'unset',
            ...(multiSelect ? { minWidth: QUANTITY_CONTROL_WIDTH } : {}),
          }}
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            // Required for touch devices who will not see the tooltip and will probably click the button
            notify(
              translateWithVariable('Please contact your admin at %{org_name} to activate a component', {
                org_name: orgName || 'your org',
              }),
              'warning'
            )
          }}
        >
          <span>{translate('Select')}</span>
        </Button>
      </Tooltip>
    )
  }
}

export default SelectButton
